import {AvailabilityApiResponse} from '../../server/routes/availability/types';
import {httpGetJson} from './http';
import {getHeaderLanguageCode} from '../../shared/utils/getHeaderLanguageCode';
import {RescheduleAvailabilityApiRequestQuery} from './reschedule';
export type AvailabilityApiRequestQuery = {
  venueId?: string | null;
  proposedServices?: string | null;
  startDate?: string | null;
  endDate?: string;
};

export const filterFalseyParams = (
  args: AvailabilityApiRequestQuery | RescheduleAvailabilityApiRequestQuery,
) => {
  const params = new URLSearchParams();
  Object.entries(args).forEach(([key, value]) => {
    if (value) {
      params.append(key, value);
    }
  });
  return params;
};

export function composeFetchApiAvailability() {
  return ({
    venueId,
    proposedServices,
    startDate,
    languageCode,
  }: AvailabilityApiRequestQuery & {
    languageCode?: string | null;
  }): Promise<AvailabilityApiResponse> => {
    const params = filterFalseyParams({
      venueId,
      proposedServices,
      startDate,
    });

    const headers = getHeaderLanguageCode(languageCode);
    return httpGetJson({
      path: `/datetime-ui/api/availability?${params}`,
      options: {
        headers,
      },
    });
  };
}
